import { setFetchStartState } from '../fetchLoadable.js';
import { setAuthToken } from '../internal.js';
import { createNotLoaded, createLoaded } from '../Loadable/utils.js';
import * as actionTypes from './actionTypes.js';
export const authTokenReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.SET_TOKEN:
            return createLoaded(payload.token);
        case actionTypes.RESET_TOKEN:
            return createNotLoaded();
        case actionTypes.LOGIN_START:
            return { ...setFetchStartState(state, payload.res) };
        case actionTypes.LOGIN_ERROR:
            return { ...payload.res };
        case actionTypes.LOGIN_SUCCESS: {
            if (!payload.res.data.twoFactorRequired) {
                setAuthToken(payload.res.data.token);
                return createLoaded(payload.res.data.token);
            }
            return createNotLoaded();
        }
        case actionTypes.VERIFY_TWO_FACTOR_START:
            return { ...setFetchStartState(state, payload.res) };
        case actionTypes.VERIFY_TWO_FACTOR_ERROR:
            return { ...payload.res };
        case actionTypes.VERIFY_TWO_FACTOR_SUCCESS: {
            setAuthToken(payload.res.data.token);
            return createLoaded(payload.res.data.token);
        }
        case actionTypes.CREATE_PASSWORD_START:
            return { ...setFetchStartState(state, payload.res) };
        case actionTypes.CREATE_PASSWORD_ERROR:
            return { ...payload.res };
        case actionTypes.CREATE_PASSWORD_SUCCESS:
            setAuthToken(payload.res.data.authToken);
            return createLoaded(payload.res.data.token);
        default:
            return state;
    }
};
export const twoFactorRequiredReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.LOGIN_START:
            return { ...setFetchStartState(state, payload.res) };
        case actionTypes.LOGIN_ERROR:
            return { ...payload.res };
        case actionTypes.LOGIN_SUCCESS:
            return payload.res.data.twoFactorRequired ? createLoaded(true) : state;
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map